import { render, staticRenderFns } from "./CurrenciesSelect.vue?vue&type=template&id=44ca1442&"
import script from "./CurrenciesSelect.vue?vue&type=script&lang=js&"
export * from "./CurrenciesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports